module.exports = __webpack_public_path__ + "static/media/notes_img.a56e566b.png";